import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScreenHelpComponent } from '@kp/screen-help/screen-help.component';

const routes: Routes = [{ path: '', component: ScreenHelpComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScreenHelpRoutingModule {
  static components = [ScreenHelpComponent];
}
